import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from './logger.service';
import { BillPaymentEhcardNumberComponent } from 'src/app/components/bill-payment-ehcard-number/bill-payment-ehcard-number.component';

var TAG = "BillPayPaymentMethod_ehCardDialogService";

@Injectable({
    providedIn: 'root'
})
export class BillPayPaymentMethod_ehCardDialogService {

    constructor(private log: LoggerService,
        private modalService: NgbModal,
    ) { }



    openDialog() {
        this.log.i(TAG, 'open Dialog');
        const modalRef = this.modalService.open(BillPaymentEhcardNumberComponent, { size: 'lg', centered: true, backdrop: 'static' });

        // modalRef.componentInstance.dataList = dataList;
        // modalRef.componentInstance.dataList_Payment = dataList_Payment;
        // modalRef.componentInstance.invoiceID = invoiceID;

        return modalRef;

    }



}
